import writeXlsxFile from 'write-excel-file'
import {CircularProgress, Dialog, DialogContent} from "@mui/material";
import {useEffect, useState} from "react";
import {useExportVouchersQuery, Voucher} from "../../../Queries";


const numberFormat = "#,##0.00"

export const ExportToExcel = async (data: Voucher[]) => {
   // @ts-ignore
   const schema: any = [{
      column: "CODE",
      type: String,
      value: (object: Voucher) => object.code
   }, {
      column: "CONSUMER",
      type: String,
      value: (object: Voucher) => object.consumer?.mail || 'unknown@mail'
   }, {
      column: "TRADEINDATE",
      type: Date,
      format: "YYYY-MM-DD",
      value: (object: Voucher) => object.tradeIn?.dateTime ? new Date(object.tradeIn?.dateTime) : undefined
   }, {
      column: "TRADERECEIVED",
      type: Boolean,
      value: (object: Voucher) => object.tradeIn?.registered || !!object.tradeIn?.registeredTs
   }, {
      column: "ISSUEDVALUE",
      type: Number,
      value: (object: Voucher) => object.value,
      format: numberFormat,
   }, {
      column: "CURRENTVALUE",
      type: Number,
      value: (object: Voucher) => object.currentValue,
      format: numberFormat,
   }, {
      column: "CURRENCY",
      type: String,
      value: (object: Voucher) => object.currency
   }, {
      column: "DAYSBEFOREUSE",
      type: Number,
      value: (object: Voucher) => object.statistics?.daysBeforeUsage,
      format: numberFormat,
   }, {
      column: "SPENDING",
      type: Number,
      value: (object: Voucher) => object.statistics?.spending,
      format: numberFormat,
   }, {
      column: "smashFactor",
      type: Number,
      value: (object: Voucher) => object.statistics?.smashFactor,
      format: numberFormat,
   }, {
      column: "usageDate",
      type: Date,
      format: "YYYY-MM-DD",
      value: (object: Voucher) => object.statistics?.usageDate ? new Date(object.statistics?.usageDate) : undefined
   }, {
      column: "ALIAS",
      type: String,
      value: (object: Voucher) => object.codeAlias
   }, {
      column: "ACTIVE",
      type: Boolean,
      value: (object: Voucher) => object.activated
   }];

   await writeXlsxFile(data, {
      schema,
      fileName: 'vouchers-' + Date.now() + '.xlsx'
   })
}

type VoucherExportProps = {
   ids: string[]
}

export const VouchersExport = ({ids}: VoucherExportProps) => {
   const [open, setOpen] = useState<boolean>(true);
   const {data} = useExportVouchersQuery({
      variables: {
         voucherIds: ids,
         currency: "DKK"
      }
   });

   useEffect(() => {
      if (data?.VoucherByIds) {
         setOpen(true);
         (async function () {
            const items = (data.VoucherByIds || []) as Voucher[]
            await ExportToExcel(items);
            setOpen(false);
         })();
      }
   }, [data, ids])

   return <Dialog open={open}>
      <DialogContent>
         <CircularProgress size={100}/>
         Preparing data, please wait...
      </DialogContent>
   </Dialog>
}